/**
 * scroll
 */
export async function headRoomInit() {
    const body = document.querySelector('body');
    const header = document.querySelector('.scrollmenu');
    const {default: Headroom} = await import('headroom.js');
    const headroom = new Headroom(header, {
        offset: header.offsetHeight,
        classes: {
            initial: 'scrollmenu',
            pinned: 'scrollmenu--pinned',
            unpinned: 'scrollmenu--unpinned',
            top: 'scrollmenu--top',
            notTop: 'scrollmenu--not-top',
            bottom: 'scrollmenu--bottom',
            notBottom: 'scrollmenu--not-bottom',
            frozen: 'scrollmenu--frozen'
        },
        onTop: function () {
            body.classList.add('js-menu-top');
        },
        onNotTop: function () {
            body.classList.remove('js-menu-top');
        },
        onPin: function () {
            body.classList.add('js-menu-visible');
        },
        onUnpin: function () {
            body.classList.remove('js-menu-visible');

            document.querySelectorAll(".js-menu--lvl0 > .js-menu__item > .js-menu-controller").forEach(item => {
                menu.closeMenu(item);
            })
        },
        tolerance: 10
    });
    headroom.init();
}